export const insuranceConfig = {
  MEASUREMENT_ID: import.meta.env.VITE_MEASUREMENT_ID,
  SMARTLOOK_PROJECT_KEY: import.meta.env.VITE_SMARTLOOK_KEY,
}
